import { COUNTRIES } from '@/helpers/constants';
export default {
    state() {
        return {
            country: COUNTRIES.includes(process.env.VUE_APP_CRM_COUNTRY) ? process.env.VUE_APP_CRM_COUNTRY : '',
        };
    },

    getters: {
    /**
     * @param {object} state
     * @return {string}
     */
        country: (state) => state.country,
    },
};